import React, { useState, useEffect, useRef } from "react"
import { Form, Container, Row, Col } from "react-bootstrap"
import Select from "react-dropdown-select"
import SearchResultInputBox from "../SearchResultBox"
import {
  removeSpecialChar,
  hyphenToCaptilize,
  QueryList,
} from "../../../components/utils/property-search"
import { isMacOs } from "react-device-detect"
import $ from "jquery"
import _ from "lodash"
import { navigate } from "@reach/router"
import "./FilterBlock.scss"

const SearchBox = ({
  aroundLatLng,
  query,
  radius,
  setRadius,
  mapresetbutton,
  mapdraggedbyuser,
  changeStateAndUrl,
}) => {
  const [department, setDepartment] = useState("2")

  const queryList = QueryList()

  const radiusOptions = [
    { value: "", label: "Radius" },
    { value: "3", label: "+ 3 miles" },
    { value: "4", label: "+ 4 miles" },
    { value: "6", label: "+ 6 miles" },
    { value: "8", label: "+ 8 miles" },
    { value: "10", label: "+ 10 miles" },
    { value: "15", label: "+ 15 miles" },
    { value: "30", label: "+ 30 miles" },
  ]

  const radiusDis = _.isEmpty(aroundLatLng)

  const departmentSelect = e => {
    setDepartment(e)
  }

  return (
    <div className="search-box results-radius-search-box">
      <div className="search-wrap">
        <SearchResultInputBox
          value={hyphenToCaptilize((query === "Kent" || query === "kent") ? "" : query)}
          setValue={(searchValue, isSelected) => {
            if (mapresetbutton.current != null) {
              mapresetbutton.current.click()
            }
            mapdraggedbyuser(false)

            //setAreaVal(searchValue)

            if (isSelected) {
              localStorage.setItem(
                "searchValue",
                removeSpecialChar(searchValue)
              )
              localStorage.setItem("searchValueFull", searchValue)
              localStorage.setItem("searchValueFullName", searchValue)

              changeStateAndUrl({ query: "" }) // previously refine("")
            } else {
              localStorage.removeItem("searchValue")
              localStorage.removeItem("searchValueFull")
              localStorage.removeItem("searchValueFullName")

              changeStateAndUrl({ query: removeSpecialChar(searchValue) }) // previously refine(query)
            }
          }}
          placeHolder={`Choose town or area`}
          areaList={queryList.areaList}
        />
      </div>

      <Select
        name="radius"
        options={radiusOptions}
        values={[
          {
            label: radius
              ? radiusOptions.filter(c => c.value == radius)[0].label
              : "Radius",
            value: radius || "",
          },
        ]}
        placeholder="Radius"
        classNamePrefix={"select-option group-dropdown"}
        isSearchable={false}
        onChange={e => {
          if (mapresetbutton.current != null) {
            mapresetbutton.current.click()
          }
          const selectedRadius = e[0].value
          setRadius(selectedRadius)
        }}
        disabled={radiusDis}
      />
    </div>
  )
}

// Property Min price
const priceminRangeSale = [
  {
    value: "",
    label: "No Min",
  },
  {
    value: "50000",
    label: "£50,000",
  },
  {
    value: "60000",
    label: "£60,000",
  },
  {
    value: "70000",
    label: "£70,000",
  },
  {
    value: "80000",
    label: "£80,000",
  },
  {
    value: "90000",
    label: "£90,000",
  },
  {
    value: "100000",
    label: "£100,000",
  },
  {
    value: "125000",
    label: "£125,000",
  },
  {
    value: "150000",
    label: "£150,000",
  },
  {
    value: "175000",
    label: "£175,000",
  },
  {
    value: "200000",
    label: "£200,000",
  },
  {
    value: "225000",
    label: "£225,000",
  },
  {
    value: "250000",
    label: "£250,000",
  },
  {
    value: "275000",
    label: "£275,000",
  },
  {
    value: "300000",
    label: "£300,000",
  },
  {
    value: "350000",
    label: "£350,000",
  },
  {
    value: "400000",
    label: "£400,000",
  },
  {
    value: "450000",
    label: "£450,000",
  },
  {
    value: "500000",
    label: "£500,000",
  },
  {
    value: "600000",
    label: "£600,000",
  },
  {
    value: "700000",
    label: "£700,000",
  },
  {
    value: "800000",
    label: "£800,000",
  },
  {
    value: "900000",
    label: "£900,000",
  },
  {
    value: "1000000",
    label: "£1,000,000",
  },
  {
    value: "1500000",
    label: "£1,500,000+",
  },
]

const priceminRangeRent = [
  {
    value: "",
    label: "No Min",
  },
  {
    value: "1000",
    label: "£1,000 PCM",
  },
  {
    value: "2000",
    label: "£2,000 PCM",
  },
  {
    value: "3000",
    label: "£3,000 PCM",
  },
  {
    value: "4000",
    label: "£4,000 PCM",
  },
  {
    value: "5000",
    label: "£5,000 PCM",
  },
]

const pricemaxRangeSale = [
  {
    value: "",
    label: "No Max",
  },
  {
    value: "50000",
    label: "£50,000",
  },
  {
    value: "60000",
    label: "£60,000",
  },
  {
    value: "70000",
    label: "£70,000",
  },
  {
    value: "80000",
    label: "£80,000",
  },
  {
    value: "90000",
    label: "£90,000",
  },
  {
    value: "100000",
    label: "£100,000",
  },
  {
    value: "125000",
    label: "£125,000",
  },
  {
    value: "150000",
    label: "£150,000",
  },
  {
    value: "175000",
    label: "£175,000",
  },
  {
    value: "200000",
    label: "£200,000",
  },
  {
    value: "225000",
    label: "£225,000",
  },
  {
    value: "250000",
    label: "£250,000",
  },
  {
    value: "275000",
    label: "£275,000",
  },
  {
    value: "300000",
    label: "£300,000",
  },
  {
    value: "350000",
    label: "£350,000",
  },
  {
    value: "400000",
    label: "£400,000",
  },
  {
    value: "450000",
    label: "£450,000",
  },
  {
    value: "500000",
    label: "£500,000",
  },
  {
    value: "600000",
    label: "£600,000",
  },
  {
    value: "700000",
    label: "£700,000",
  },
  {
    value: "800000",
    label: "£800,000",
  },
  {
    value: "900000",
    label: "£900,000",
  },
  {
    value: "1000000",
    label: "£1,000,000",
  },
  {
    value: "1500000",
    label: "£1,500,000+",
  },
]

const pricemaxRangeRent = [
  {
    value: "",
    label: "No Max",
  },
  {
    value: "1000",
    label: "£1,000 PCM",
  },
  {
    value: "2000",
    label: "£2,000 PCM",
  },
  {
    value: "3000",
    label: "£3,000 PCM",
  },
  {
    value: "4000",
    label: "£4,000 PCM",
  },
  {
    value: "5000",
    label: "£5,000 PCM",
  },
]

var minpriceval = minpriceval || ""
var maxpriceval = maxpriceval || ""

const CustomMinPriceSelector = ({
  currentRefinement = {},
  defaultRefinement = {},
  changeStateAndUrl,
  value,
  sales,
  currentState
}) => {
  const selectedArr = sales ? priceminRangeSale : priceminRangeRent
  const minVal = currentRefinement.min || defaultRefinement.min || ""
  const maxVal = currentRefinement.max || defaultRefinement.max || ""

  let minPriceRange = selectedArr

  if (maxVal !== "") {
    minPriceRange = selectedArr.filter(
      x => parseInt(x.value) < parseInt(maxVal) || x.value === ""
    )
  }

  const minpval =
    minVal === ""
    ? undefined
    : minPriceRange.find(obj => obj.value == minVal) ||
      minPriceRange.find(obj => obj.value == value);

  const handleChange = event => {
    if (!event.length) return

    const selected = event[0].value

    const newState = {
      ...currentState,
      page: 0,
    }

    if (selected === "") {
      newState.range = {
        ...newState.range,
        price: {
          max: maxVal || undefined,
        },
      }
    } else {
      newState.range = {
        ...newState.range,
        price: {
          min: selected,
          max: maxVal || undefined,
        },
      }
    }
    changeStateAndUrl(newState)
  }

  return (
    <div
      className={
        isMacOs === true ? "filter-option mac-select-dropdown" : "filter-option"
      }
    >
      <Select
        name="minprice"
        values={minpval ? [minpval] : []}
        options={minPriceRange}
        placeholder="Min Price"
        searchable={false}
        classNamePrefix="select-opt"
        onChange={handleChange}
      />
    </div>
  )
}

const MaxPriceSelectbox = ({
  currentRefinement,
  defaultRefinement,
  value,
  sales,
  currentState,
  changeStateAndUrl,
}) => {
  let selecedArr = sales ? pricemaxRangeSale : pricemaxRangeRent
  const minVal = currentRefinement.min || defaultRefinement.min || ""

  let maxPriceRange = selecedArr
  let maxpricedisable = ""

  const current = currentRefinement || defaultRefinement || {}
  if (minVal !== "" ) {
    maxPriceRange = selecedArr.filter(
      x => parseInt(x.value) > parseInt(current.min) || x.value === ""
    )
  }

  if (current.min == "10000000") {
    maxpricedisable = "disabled"
  }

  const maxpval =
    current.max === ""
    ? undefined
    : maxPriceRange.find(obj => obj.value == current.max) ||
    maxPriceRange.find(obj => obj.value == value)

  return (
    <div
      className={
        isMacOs === true ? "filter-option mac-select-dropdown" : "filter-option"
      }
    >
      <Select
        name="maxprice"
        disabled={maxpricedisable}
        values={maxpval ? [maxpval] : []}
        placeholder="Max Price"
        options={maxPriceRange}
        searchable={false}
        onChange={event => {
          if (event.length > 0) {
            const maxpriceval = event[0].value

            const newState = {
              ...currentState,
              page: 0,
            }

            if (maxpriceval === "") {
              newState.range = {
                ...newState.range,
                price: {
                  min: current.min,
                },
              }
            } else {
              newState.range = {
                ...newState.range,
                price: {
                  min: current.min,
                  max: maxpriceval,
                },
              }
            }
            changeStateAndUrl(newState)
          }
        }}
      />
    </div>
  )
}

const beds = [
  { label: "Beds", value: "" },
  { label: "Studio", value: "0" },
  { label: "1+", value: "1" },
  { label: "2+", value: "2" },
  { label: "3+", value: "3" },
  { label: "4+", value: "4" },
  { label: "5+", value: "5" },
]

// Property Bedrooms
const BedroomSelectbox = ({
  currentRefinement,
  currentState,
  changeStateAndUrl,
}) => {
  let bedroomVal = String(currentRefinement)
  const selected = beds.find(obj => obj.value == String(bedroomVal))

  return (
    <div
      className={
        isMacOs === true ? "filter-option mac-select-dropdown" : "filter-option"
      }
    >
      <Select
        searchable={false}
        options={beds}
        multi={false}
        placeholder="Beds"
        values={selected ? [selected] : []}
        onChange={event => {
          const value = event[0]?.value

          const newState = {
            ...currentState,
            page: 0,
          }

          if (value == "") {
            newState.range = {
              ...newState.range,
              bedroom: { min: 0 },
            }
          } else if (value === "0") {
            newState.range = {
              ...newState.range,
              bedroom: { max: 0 },
            }
          } else {
            newState.range = {
              ...newState.range,
              bedroom: { min: value },
            }
          }

          changeStateAndUrl(newState)
        }}
      />
    </div>
  )
}

const saleBuildings = [
  { label: "All", value: "" },
  { label: "Houses", value: "house" },
  { label: "Flats", value: "flats" },
  { label: "Bungalows", value: "bungalow" },
  { label: "Mobile homes", value: "mobile-home" },
  { label: "Character property", value: "character-property" },
  { label: "Garage", value: "garage" },
  { label: "New Homes", value: "new-homes" },
]

const letBuildings = [
  { label: "All", value: "" },
  { label: "House", value: "house" },
  { label: "Flats", value: "flats" },
  { label: "Bungalow", value: "bungalow" },
  { label: "house flat share", value: "house-flat-share" },
]

// Property Type
const PropertyTypeFilter = ({
  value,
  sales,
  currentState,
  changeStateAndUrl,
}) => {
  let propertyType = value || ""

  let buildings = sales ? saleBuildings : letBuildings

  let typeval = propertyType
    ? buildings.find(obj => obj.value === propertyType)
    : null

  return (
    <div
      className={
        isMacOs === true ? "filter-option mac-select-dropdown" : "filter-option"
      }
    >
      <Select
        searchable={false}
        options={buildings}
        placeholder="All"
        value={value}
        values={typeval ? [typeval] : []}
        onChange={event => {
          const selectedVal = event[0].value

          changeStateAndUrl({
            ...currentState,
            menu: {
              searchBuilding: selectedVal,
            },
            page: 0,
          })
        }}
      />
    </div>
  )
}

// Popular Filter

// More Filters
const TogglePromotionRefinement = ({
  defaultRefinement = [],
  options = [],
  currentState = {},
  changeStateAndUrl,
}) => {
  const didInit = useRef(false)

  const [selectedPromotions, setSelectedPromotions] = useState([])

  useEffect(() => {
    if (!didInit.current) {
      didInit.current = true
      return
    }

    // Active checkmarks
    if (selectedPromotions.length > 0) {
      $(".more-clear-refine").addClass("active")
      changeStateAndUrl({
        ...currentState,
        page: 0,
        property_promotions: selectedPromotions,
      })
    } else {
      $(".more-clear-refine").removeClass("active")
      const updatedState = { ...currentState }
      delete updatedState.property_promotions
      changeStateAndUrl({ ...updatedState, selectedpromotions: "reset", page: 0 })
    }
  }, [selectedPromotions])

  const handleCheckboxChange = (promoId, checked) => {
    setSelectedPromotions(prev => {
      if (checked) {
        return [...prev, promoId]
      } else {
        return prev.filter(id => String(id) !== String(promoId))
      }
    })
  }

  const handleClear = () => {
    setSelectedPromotions([])
  }

  useEffect(() => {
    if (Array.isArray(defaultRefinement) && defaultRefinement.length > 0) {
      setSelectedPromotions(defaultRefinement)
    }
  }, [defaultRefinement])

  return (
    <ul className="offer-list">
      {options.map((item, key) => (
        <li key={key}>
          <Form.Group className="mb-0 must-include-check" controlId={item.name}>
            <Form.Check
              type="checkbox"
              label={item.name}
              value={item.promo_id}
              checked={selectedPromotions.includes(String(item.promo_id))}
              onChange={e =>
                handleCheckboxChange(e.target.value, e.target.checked)
              }
            />
          </Form.Group>
        </li>
      ))}
      <li className="more-clear-refine" onClick={handleClear}>
        Clear
      </li>
    </ul>
  )
}

// More Filters

const FilterBlock = props => {
  const [show, setShow] = useState(false)
  const showMenu = () => {
    setShow(!show)

    $(".search-template").toggleClass("filter-active")
  }
  const [department, setDepartment] = useState("+2 Miles")
  const departmentSelect = e => {
    setDepartment(e)
  }
  const queryList = QueryList()
  const [promotions, setPromotions] = useState(queryList.promotionList)

  // localStorage.setItem("pagesearchType", props?.searchType)
  // fixing build time error
  useEffect(() => {
    if (typeof window !== "undefined") {
      localStorage.setItem("pagesearchType", props?.searchType)
    }
  }, [props?.searchType])

  const query = props.query

  const min = props.min === "" ? undefined : parseInt(props.min)
  const max = props.max === "" ? undefined : parseInt(props.max)

  const bedrooms = props.bedrooms === "" ? undefined : parseInt(props.bedrooms)
  const building = props.building
  const promotions_value = props.property_promotions

  function fitlerDisplay(e) {
    $(".dropdown-exp").toggleClass("active")
  }
  // Apply search mobile
  const applySearchMobile = () => {
    setShow(!show)
    $(".search-template").removeClass("filter-active")
    $(".filter").removeClass("filter-active")
    $("filter-field").removeClass("show-fliter")
  }
  // Apply search mobile
  // Sales & Rent
  function onClickBuy(e) {
    let searchInput = $("#search-address-filter").val()
    if (searchInput === "") {
      localStorage.removeItem("searchValue")
      localStorage.removeItem("searchValueFull")
      localStorage.removeItem("searchValueFullName")
    }
    if (localStorage.getItem("searchValue")) {
      navigate(
        `/property/for-sale/in-${localStorage.getItem(
          "searchValue"
        )}/radius-3-miles`
      )
    } else {
      navigate(`/property/for-sale/in-kent/`)
    }
  }
  function onClickRent(e) {
    let searchInput = $("#search-address-filter").val()
    if (searchInput === "") {
      localStorage.removeItem("searchValue")
      localStorage.removeItem("searchValueFull")
      localStorage.removeItem("searchValueFullName")
    }
    if (localStorage.getItem("searchValue")) {
      navigate(
        `/property/to-rent/in-${localStorage.getItem(
          "searchValue"
        )}/radius-3-miles`
      )
    } else {
      navigate(`/property/to-rent/in-kent/`)
    }
  }
  // Sales & Rent
  return (
    <React.Fragment>
      <div className={show ? "filter filter-active" : "filter"}>
        <button className="filter-show">
          {" "}
          Refine Search{" "}
          <i
            className={
              show ? "icon-minue-white icon-plus-white " : "icon-plus-white "
            }
            onClick={showMenu}
          ></i>
        </button>
        <div className={show ? "filter-field show-fliter " : "filter-field "}>
          <Container>
            <Row>
              <Col className="filter-fixed ">
                <Form className="form-data">
                  <div className="radio-form">
                    <Form.Check
                      type="radio"
                      label="Buy"
                      name="propertyRadio"
                      id="propertyRadio1"
                      className="buy-radio"
                      checked={props.searchType == "sales" ? true : false}
                      onClick={() => {
                        onClickBuy()
                      }}
                    />
                    <Form.Check
                      type="radio"
                      label="Rent"
                      name="propertyRadio"
                      className="rent-radio"
                      id="propertyRadio2"
                      checked={props.searchType == "lettings" ? true : false}
                      onClick={() => {
                        onClickRent()
                      }}
                    />
                  </div>
                  {!props.searchDisable && (
                    <SearchBox
                      aroundLatLng={props.aroundLatLng}
                      defaultRefinement={query}
                      query={query}
                      radius={props.radius}
                      setRadius={props.changeRadius}
                      showLoadingIndicator={false}
                      algoliaConfig={props.algoliaConfig}
                      mapresetbutton={props.buttonrest}
                      changeStateAndUrl={props.changeStateAndUrl}
                      mapdraggedbyuser={props.mapdraggedbyuser}
                    />
                  )}
                  <div className="box-wrapper">
                    <div className="select-boxes buy-select">
                      <label>Property Type</label>
                      <PropertyTypeFilter
                        value={props.building}
                        defaultRefinement={props.building}
                        sales={props.sales}
                        currentState={props}
                        changeStateAndUrl={props.changeStateAndUrl}
                      />
                    </div>
                    <div className="select-boxes min-price-select">
                      <label>Min Price</label>
                      <CustomMinPriceSelector
                        currentRefinement={{ min: props.min, max: props.max }}
                        defaultRefinement={{ min: props.min, max: props.max }}
                        value={props.min}
                        sales={props.sales}
                        currentState={props}
                        changeStateAndUrl={props.changeStateAndUrl}
                      />
                    </div>
                    <div className="select-boxes max-price-select">
                      <label>Max Price</label>
                      <MaxPriceSelectbox
                        currentRefinement={{ min: props.min, max: props.max }}
                        defaultRefinement={{ min: props.min, max: props.max }}
                        value={props.max}
                        sales={props.sales}
                        currentState={props}
                        changeStateAndUrl={props.changeStateAndUrl}
                      />
                    </div>
                    <div className="select-boxes bedroom-select">
                      <label>Bedrooms</label>
                      <BedroomSelectbox
                        currentState={props}
                        currentRefinement={props.bedrooms} // from search state
                        changeStateAndUrl={props.changeStateAndUrl}
                      />
                    </div>
                    <div className="select-boxes type-select more-filter-select custom-filter-box">
                      <a
                        className="label filter-dropdown add-more-btn-mobile-filter"
                        href="javascript:void(0)"
                        onClick={() => fitlerDisplay()}
                      >
                        <i className="icon-filter-more"></i>
                        <span>More Filters</span>
                      </a>
                      <div className="dropdown-exp" id="filter-drop-main">
                        <div className="added">
                          <label>Filters:</label>
                        </div>
                        <TogglePromotionRefinement
                          defaultRefinement={promotions_value}
                          options={promotions}
                          currentState={props}
                          changeStateAndUrl={props.changeStateAndUrl}
                        />
                      </div>
                    </div>
                    <div className="d-md-none d-block">
                      <a
                        href="javascript:void(0)"
                        className="btn btn-secondary w-100"
                        onClick={applySearchMobile}
                      >
                        Apply
                      </a>
                    </div>
                  </div>
                </Form>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </React.Fragment>
  )
}
export default FilterBlock
